<template>
  <header :class="{ sticky, top, home: $route.path === '/' }">
    <div class="inner cg">
      <router-link to="/">
        <img src="@/assets/logo.png" alt="M2P">
      </router-link>
      <div :class="{ active: showMenu }" class="wrapper">
        <div class="nav">
          <div class="group">
            <router-link to="/citizenship">Citizenship</router-link>
            <div class="nested">
              <div class="nested__inner cg"  >
                <router-link v-for="( citizenship) in citizenships" :to="'/'+citizenship.category+'/'+citizenship.slug">{{citizenship.name}}</router-link>
                <!--<router-link to="/citizenship/grenada">Grenada</router-link>
                <router-link to="/citizenship/dominica">Dominica</router-link>
                <router-link to="/citizenship/malta">Malta</router-link>-->
              </div>
            </div>
          </div>
          <router-link to="/residence">Residence</router-link>
          <router-link to="/compare">Compare products</router-link>
          <router-link to="/blog">Blog</router-link>
          <router-link to="/about">About Us</router-link>
          <router-link to="/contact">Contact Us</router-link>
        </div>


        <div class="lang" @click="toggleLang">
          <div class="lang__item active">English</div>
          <div :class="{ active: showLang }" class="lang__list">
            <div class="lang__item">
              <a href="http://my2ndpassport.ru">Русский</a>
            </div>
          </div>
        </div>

        <!--
        <div class="lang" @click="toggleLang">
          <div class="lang__item active">{{ language }}</div>
          <div :class="{ active: showLang }" class="lang__list">
            <div
              v-for="lang in secondaryLanguages"
              :key="lang"
              class="lang__item"
              @click="language = lang">
              {{ lang }}
            </div>
          </div>
        </div>
        -->

        <close class="close" @click="toggleMenu">✕</close>
      </div>
      <burger @click="toggleMenu"/>
    </div>
  </header>
</template>

<script>
import Burger from './burger';
import Close from './close';
import throttle from 'lodash.throttle';
import axios from "axios";

export default {
  components: { Burger, Close },
  data() {
    const languages = [
      'English',
      'Russian'
    ];

    return {
      showMenu: false,
      showLang: false,
      sticky: false,
      prevScroll: 0,
      languages,
      language: languages[0],
      citizenships:[]
    }
  },
  computed: {
    secondaryLanguages() {
      return this.languages.filter(lang => lang !== this.language);
    },
    top() {
      return this.prevScroll < 50;
    },
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleLang() {
      this.showLang = !this.showLang;
    }
  },
  mounted() {
    document.addEventListener('scroll', throttle(() => {
      const top = document.documentElement.scrollTop;
      this.sticky = top < this.prevScroll;
      this.$store.commit('toggleHeader', this.sticky);
      this.prevScroll = top;
    }, 300));

    axios.post('https://api.my2ndpassport.com/getproducts', {
    }).then(response => {
      this.citizenships = response.data.citizenships;
    })


  },
  watch: {
    $route() {
      this.showMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

header {
  position: fixed;
  z-index: 100;
  transition: all 0.3s;
  top: 0;
  left: 0;
  right: 0;

  transform: translateY(-100%);

  &.sticky {
    transform: translateY(0);
  }

  &.top {
    transform: translateY(0);
  }

  &:not(.home),
  &:hover,
  &.sticky {
    background: #fff;
    box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
  }
}

.inner {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wrapper {
  @include mobile {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    height: 110vh;
    min-height: 650px;
    width: 100vw;
    background: 
      url('../assets/nav.png') no-repeat right 30px bottom 20px,
      linear-gradient(to right, #3e81ac 0%, #3486ac 100%);
    color: #fff;
    padding: 20px;
    transition: all 0.3s;
    display: flex;
    flex-flow: column-reverse;
    justify-content: flex-end;
    opacity: 0;
    pointer-events: none;

    &.active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  @include desktop {
    display: flex;
    flex-grow: 1;
    height: 100%;
  }
}

.nav {
  font-size: 14px;
  font-weight: 500;
  display: grid;
  grid-gap: 35px;

  @include desktop {
    grid-auto-flow: column;
    margin: 0 auto;
    align-items: center;
  }

  a {
    text-decoration: none;
    position: relative;

    @include mobile {
      color: #ffffff;
      font-size: 24px;
    }

    @include desktop {
      color: #484848;
    }

    &:before {
      position: absolute;
      bottom: -3px;
      width: 100%;
      height: 2px;
      transform: scaleX(0);
      transition: all 0.3s;
      background: #83ca54;

      @include desktop {
        content: '';
      }
    }

    &:hover,
    &.router-link-active {
      &:before {
        transform: scaleX(1);
      }
    }

    &.router-link-active {
      color: #83ca54;
    }
  }
}

.group {
  @include desktop {
    display: flex;
    align-items: center;
    height: 100%;
  }

  & > *:first-child {
    display: flex;
    align-items: center;

    &:after {
      content: '';
      width: 20px;
      height: 20px;
      margin-left: 5px;

      @include mobile {
        background: url('../assets/arrow-white.png') no-repeat center;
      }

      @include desktop {
        background: url('../assets/arrow.png') no-repeat center;
        transform: rotate(-90deg);
      }
    }
  }

  &:hover {
    .nested {
      opacity: 1;
      pointer-events: auto;
    }
  }
}

.nested {
  padding: 13px 0;
  font-size: 14px;

  @include mobile {
    padding-bottom: 0;
  }

  @include desktop {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background-image: linear-gradient(to right, #131e43 0%, #14245a 100%);
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
  }

  &__inner {
    display: grid;
    grid-gap: 30px;

    @include desktop {
      grid-auto-flow: column;
      justify-content: center;
    }
  }

  a {
    color: #ffffff;
    text-decoration: none;

    &.router-link-active {
      font-weight: 700;
      color: #83ca54;
    }
  }
}

.lang {
  position: relative;
  cursor: pointer;

  @include mobile {
    display: flex;
    margin-bottom: 40px;

    & > * {
      margin-right: 30px;
    }
  }

  @include desktop {
    align-self: center;
  }

  &__list {
    @include desktop {
      background: #fff;
      position: absolute;
      box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
      top: calc(100% + 10px);
      right: 0;
      transition: all 0.3s;
      pointer-events: none;
      opacity: 0;
    }

    @include mobile {
      opacity: 1 !important;
    }

    &.active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &__item {
    &:not(.active) {
      @include desktop {
        padding: 10px 20px;
        border-bottom: 1px solid #e5e5e5;
      }
    }

    &.active {
      @include mobile {
        font-weight: 700;
      }

      @include desktop {
        display: flex;
        align-items: center;
        
        &:after {
          content: '';
          display: inline-block;
          margin-left: 10px;
          background: url('../assets/arrow.png') no-repeat center;
          width: 20px;
          height: 20px;
          transform: rotate(-90deg);
        }
      }
    }
  }

  a {
    color:#484848;
    text-decoration:none;
  }

}

.close {
  align-self: flex-end;

  @include desktop {
    display: none;
  }
}
</style>